import { render, staticRenderFns } from "./NewContractSidebar.vue?vue&type=template&id=cb484b72&scoped=true&"
import script from "./NewContractSidebar.vue?vue&type=script&lang=js&"
export * from "./NewContractSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb484b72",
  null
  
)

export default component.exports